import React, { FC } from "react";
import { observer } from "mobx-react";
import achCard from "../../../../../images/payment/ach_card_logo.svg";
import amexCard from "../../../../../images/payment/amex_card_logo.svg";
import masterCard from "../../../../../images/payment/master_card_logo.svg";
import visaCard from "../../../../../images/payment/visa-card_logo.svg";
import discoverIcon from "../../../../../images/payment/discover.svg";
import { PaymentMethodModel } from "../models";
import { PaymentMethodPriority } from "../enums";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

type IProps = {
  paymentMethod?: PaymentMethodModel;
  showPriority?: boolean;
};
export const RenderPaymentMethodWrapper = styled.div`
  .render-card-icons {
    width: 30px;
    height: 20px;
  }
`;

const RenderPaymentMethod: FC<IProps> = ({
  paymentMethod,
  showPriority = false,
}) => {
  if (!paymentMethod?.card && !paymentMethod?.bank) return null;
  const cardIcon = (type: string) => {
    switch (type?.toLowerCase()) {
      case "amex":
      case "american_express":
        return amexCard;
      case "mastercard":
        return masterCard;
      case "ach":
        return achCard;
      case "discover":
        return discoverIcon;
      default:
        return visaCard;
    }
  };

  const color =
    paymentMethod.priority === PaymentMethodPriority?.Primary
      ? "#579836"
      : "#6A7AB5";
  const bgColor =
    paymentMethod.priority === PaymentMethodPriority?.Primary
      ? "#EEF7EA"
      : "#ECF0FF";

  return (
    <RenderPaymentMethodWrapper>
      <FlexContainer alignItems="center" spacing={15}>
        {paymentMethod.card && (
          <img
            src={cardIcon(paymentMethod.card.brand)}
            className="render-card-icons"
          />
        )}
        {paymentMethod.bank && (
          <img src={achCard} className="render-card-icons" />
        )}
        <CustomLabel fontSize={"16px"} lineHeight="20px" className="clickable">
          {" "}
          {paymentMethod.card
            ? `...${paymentMethod.card?.last4}`
            : `${paymentMethod.bank?.maskedAccount}`}
        </CustomLabel>
        {showPriority && (
          <CustomButton bgColor={bgColor} color={color} className="status-btn">
            {PaymentMethodPriority[paymentMethod.priority]}
          </CustomButton>
        )}
      </FlexContainer>
    </RenderPaymentMethodWrapper>
  );
};

export default observer(RenderPaymentMethod);
